import React from 'react'
import PropTypes from 'prop-types'

// Components
import { Text } from 'src/Components'

// Styles
import styles from './FeatureSection.module.scss'

const FeatureSection = ({ className, image, title, description }) => (
  <div className={className}>
    {image}
    <Text
      align='left'
      element='h2'
      size='xl'
      variant='neutralCool'
      variantCount='600'
      className={styles.title}
    >
      {title}
    </Text>
    <Text variant='neutralCool' variantCount='800'>
      {description}
    </Text>
  </div>
)

FeatureSection.propTypes = {
  className: PropTypes.string,
  image: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
}

export default FeatureSection
